module.exports = __webpack_public_path__ + "static/media/22_twitter_image.227c0def.jpg";